import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { ErrorState } from '@/components/ErrorState'

interface ProjectUnavailableProps {
  isGone: boolean
  isRetrying: boolean
  onRetry: () => void
}

export function ProjectUnavailable({ isGone, isRetrying, onRetry }: ProjectUnavailableProps) {
  return (
    <ErrorState
      testId="project-unavailable"
      title={isGone ? 'This project is no longer available' : 'Could not load this project'}
      description={
        isGone
          ? 'It may have been deleted or decommissioned, or your access to it may have been removed.'
          : 'Something went wrong while loading the project. Please try again.'
      }
      onRetry={isGone ? undefined : onRetry}
      isRetrying={isRetrying}
    >
      <Button asChild variant={isGone ? 'outline' : 'ghost'}>
        <Link to="/projects">Back to All Projects</Link>
      </Button>
    </ErrorState>
  )
}
